"use strict";

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReactiveMap = exports.ReactiveMapProvider = exports.useWriteSharedState = exports.useReadSharedState = exports.useReactiveMap = exports.useSharedState = void 0;

var tslib_1 = require("tslib");

var config_hopin_constants_1 = require("@hopin-team/config-hopin-constants");

var react_core_1 = require("@slicesjs/react-core");

var reactive_map_launchdarkly_1 = require("@slicesjs/reactive-map-launchdarkly");

var LDClient = tslib_1.__importStar(require("launchdarkly-js-client-sdk"));

var helpers_1 = require("./helpers");

exports.useSharedState = (_a = (0, react_core_1.createReactBindings)(), _a.useSharedState), exports.useReactiveMap = _a.useReactiveMap, exports.useReadSharedState = _a.useReadSharedState, exports.useWriteSharedState = _a.useWriteSharedState, exports.ReactiveMapProvider = _a.SlicesProvider;

function createReactiveMap() {
  var reactiveMap = new react_core_1.ReactiveMap({
    allowedKeys: ['feature_flags'],
    allowedContextKeys: ['launchdarkly_client']
  });
  reactiveMap.addMapContext('launchdarkly_client', new Promise(function (resolve, reject) {
    function createLaunchDarkly() {
      var _a;

      return tslib_1.__awaiter(this, void 0, void 0, function () {
        var eventSlug, ldClient;
        return tslib_1.__generator(this, function (_b) {
          eventSlug = (_a = (0, helpers_1.getEventSlugFromPath)(window.location.pathname)) !== null && _a !== void 0 ? _a : '';
          ldClient = LDClient.initialize(getLaunchdarklyClientID(), {
            kind: 'user',
            key: 'eventSlug',
            custom: {
              eventSlug: eventSlug
            }
          });
          ldClient.on('error', function (error) {
            return console.error('Launch darkly client encountered an error', error);
          });
          ldClient.on('failed', function (error) {
            console.error('Unable to initialise launch darkly client', error);
            reject(error);
          });
          ldClient.on('initialized', function () {
            reactiveMap.item('feature_flags').set(ldClient.allFlags());
            resolve(ldClient);
          });
          ldClient.on('ready', function () {
            if (!isDevMode()) return;
            console.log('initialization succeeded, flag values are now available');
            console.log(getOnsiteFlags(ldClient.allFlags()));
          });
          return [2
          /*return*/
          ];
        });
      });
    }

    createLaunchDarkly();
  }));
  reactiveMap.item('feature_flags', {
    initialiser: noFlagsWhileLoading
  }).connect('launchdarkly_client', reactive_map_launchdarkly_1.connector);
  return reactiveMap;
}

exports.createReactiveMap = createReactiveMap;

function getLaunchdarklyClientID() {
  var env = process.env.NODE_ENV;

  switch (env) {
    case 'production':
      return config_hopin_constants_1.LAUNCH_DARKLY_CLIENT_IDS.production;

    case 'development':
    case 'test':
      return config_hopin_constants_1.LAUNCH_DARKLY_CLIENT_IDS.development;

    default:
      throw new Error("process env not valid: ".concat(env));
  }
}

function noFlagsWhileLoading() {
  return {};
}

function getOnsiteFlags(flags) {
  return Object.entries(flags).filter(function (_a) {
    var _b = tslib_1.__read(_a, 2),
        key = _b[0],
        _value = _b[1];

    return key.startsWith('onsite');
  });
}

function isDevMode() {
  return process.env.NODE_ENV === 'development';
}